import { iSubRoute } from "../../../definitions/interfaces"

export function getArtifactRoutes({ urlPrefix = "" }) {
  return routes.map((r) => ({ ...r, route: urlPrefix + r.route }))
}

const routes: iSubRoute[] = [
  {
    title: "Overview",
    route: "",
  },
  {
    title: "Details",
    route: "/details",
  },
  {
    title: "Uploads",
    route: "/manage-files",
  },
]
